import {
  BasicFishermanBannerBody,
  CenterStackedBody,
  CenterStackedVTwoBody,
  ExtensiveSitemapBody,
  ServicesBody,
  SimpleBody,
  SubscriptionBannerBody,
} from './components/body';
import {
  BasicFishermanBannerFooter,
  CenterStackedFooter,
  CenterStackedVTwoFooter,
  ExtensiveSitemapFooter,
  ServicesFooter,
  SimpleFooter,
  SubscriptionBannerFooter,
} from './components/footer';

const VariantMap = {
  mainBody: {
    ExtensiveSitemap: ExtensiveSitemapBody,
    CenterStacked: CenterStackedBody,
    BasicFishermanBanner: BasicFishermanBannerBody,
    CenterStackedV2: CenterStackedVTwoBody,
    Simple: SimpleBody,
    Services: ServicesBody,
    SubscriptionBanner: SubscriptionBannerBody,
  },
  footer: {
    ExtensiveSitemap: ExtensiveSitemapFooter,
    CenterStacked: CenterStackedFooter,
    BasicFishermanBanner: BasicFishermanBannerFooter,
    CenterStackedV2: CenterStackedVTwoFooter,
    Simple: SimpleFooter,
    Services: ServicesFooter,
    SubscriptionBanner: SubscriptionBannerFooter,
  },
};

export default VariantMap;
